var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50419 6.15C9.33169 5.925 9.12169 5.73 8.92669 5.535C8.42419 5.085 7.85419 4.7625 7.37419 4.29C6.25669 3.195 6.00919 1.3875 6.72169 0C6.00919 0.1725 5.38669 0.5625 4.85419 0.99C2.91169 2.55 2.14669 5.3025 3.06169 7.665C3.09169 7.74 3.12169 7.815 3.12169 7.9125C3.12169 8.0775 3.00919 8.2275 2.85919 8.2875C2.68669 8.3625 2.50669 8.3175 2.36419 8.1975C2.31919 8.16 2.28919 8.1225 2.25919 8.07C1.41169 6.9975 1.27669 5.46 1.84669 4.23C0.594192 5.25 -0.0883074 6.975 0.00919255 8.6025C0.0541926 8.9775 0.0991925 9.3525 0.226693 9.7275C0.331693 10.1775 0.534193 10.6275 0.759193 11.025C1.56919 12.3225 2.97169 13.2525 4.47919 13.44C6.08419 13.6425 7.80169 13.35 9.03169 12.24C10.4042 10.995 10.8842 9 10.1792 7.29L10.0817 7.095C9.92419 6.75 9.50419 6.15 9.50419 6.15ZM7.13419 10.875C6.92419 11.055 6.57919 11.25 6.30919 11.325C5.46919 11.625 4.62919 11.205 4.13419 10.71C5.02669 10.5 5.55919 9.84 5.71669 9.1725C5.84419 8.5725 5.60419 8.0775 5.50669 7.5C5.41669 6.945 5.43169 6.4725 5.63419 5.955C5.77669 6.24 5.92669 6.525 6.10669 6.75C6.68419 7.5 7.59169 7.83 7.78669 8.85C7.81669 8.955 7.83169 9.06 7.83169 9.1725C7.85419 9.7875 7.58419 10.4625 7.13419 10.875Z",
    fill: "#C45420"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.871a06ed0028bb1ab349c384770866fc.svg";
export { ForwardRef as ReactComponent };